<template>
    <b-modal
            id="import-xero-pay-items"
            ref="import-xero-pay-items"
            size="lg-size"
            modal-class="modal-xero"
            no-close-on-esc
            no-close-on-backdrop
            centered
            hide-footer
            hide-header
            @hide="close"
    >
        <div class="modal-head">
            <h2 class="modal-title">
                {{ 'Pay Items'}}
            </h2>
            <div class="quickbooks-logo">
                <img
                        src="/assets/images/xero-logo-blue.svg"
                        alt="Atto"
                        class="black-logo"
                        width="50"
                        height="50"
                >
            </div>
        </div>
        <div class="content-wrapper quickbooks-container">
            <div class="login-container signup-quickbooks synchronize-container">
                <h4>{{'Map your Xero pay items to the relevant category recorded in Atto. You can only select one pay item per category.'}}</h4>
                <div class="s-team-wrapper body-container">
                    <div class="head-labels">
                        <div class="label email">
                            <p>
                                {{'Category'}}
                            </p>
                        </div>
                        <div class="label">
                            <p>
                                {{'Earnings Name'}}
                            </p>
                        </div>
                    </div>
                    <ul class="quickbooks-member-list">
                        <li>
                            <div class="field-row">
                                <div class="member-name">
                                    <p class="member-name">
                                        {{ 'Regular Hours' }}
                                    </p>
                                </div>
                                <div class="member-name">
                                    <select-dropdown-component
                                            v-model="regular_selected_id"
                                            placeholder="Select Regular:"
                                            :options="regularHours"
                                            @onOptionSelected="onRegularSelected"
                                    />
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="field-row">
                                <div class="member-name">
                                    <p class="member-name">
                                        {{ 'Overtime Hours' }}
                                    </p>
                                </div>
                                <div class="member-name">
                                    <select-dropdown-component
                                            v-model="overtime_selected_id"
                                            placeholder="Select Overtime:"
                                            :options="overtimeHours"
                                            @onOptionSelected="onOvertimeSelected"
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
               <span v-if="errorMessage" class="error-message" style="padding-left: 48px;">
                {{errorMessage}}
               </span>
            </div>
        </div>
        <div class="modal-footer">
            <button
                    type="reset"
                    class="atto-btn cancel"
                    data-dismiss="modal"
                    @click="close"
            >
                {{label.get('cancel')}}
            </button>
            <button
                    class="atto-btn submit"
                    type="submit"
                    @click="submit"
            >
                {{'SAVE CHANGES'}}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import CompanyService from "../services/CompanyService";
    import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";

    export default {
        name: "ImportXeroPayItemsComponent",
        components: {
            SelectDropdownComponent
        },
        data() {
            return {
                regularHours: [],
                overtimeHours: [],
                regular_selected: null,
                regular_selected_id: null,
                overtime_selected: null,
                overtime_selected_id: null,
                errorMessage : ''
            }
        },
        mounted() {
            const _this = this;
            document.body.appendChild(this.$el);
            this.$store.commit('showLoading');
            CompanyService.getXeroPayItems().then((result) => {
                if(result.overtime_selected !== null){
                    _this.overtime_selected_id = result.overtime_selected.value;
                }
                if(result.regular_selected !== null){
                    _this.regular_selected_id = result.regular_selected.value;
                }

                _this.overtime_selected = result.overtime_selected;
                _this.regular_selected = result.regular_selected;
                _this.regularHours = result.regular;
                _this.overtimeHours = result.overtime;
                _this.$refs['import-xero-pay-items'].show();
                _this.$store.commit('hideLoading');
            }).catch(error => {
                this.$store.commit('hideLoading');
                if(error.response.status === 403 ){
                    this.$store.commit('xeroHasError403', true);
                    this.$root.$emit('showXeroErrors');
                }
                this.errorMessage = error.response.data.error.message;
            });
        },
        methods: {
            submit() {

                const data = {
                    regular: this.regular_selected,
                    overtime: this.overtime_selected,
                };

                CompanyService.postXeroPayItems(data).then((result) => {
                    this.$awn.success('Pay items updates successfully');
                    this.$root.$emit('hideXeroPayItemsImport');
                }).catch(error => {
                    debugger;
                    this.errorMessage = error.response.data.error.message;
                });

            },
            close() {
                this.$root.$emit('hideXeroPayItemsImport');
            },
            onOvertimeSelected(value){
                this.overtime_selected = value;
            },
            onRegularSelected(value){
                this.regular_selected = value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal-xero{
        .modal-lg-size {
            .modal-content {
                .modal-body {
                    .content-wrapper {

                        h4{
                            padding-left: 48px;
                            max-width: 525px;
                            margin-bottom: 1.5rem;
                        }
                        ul.quickbooks-member-list > li{
                            padding: 8px 48px 0;

                            .member-name{
                                p{
                                    padding-left: 12px;
                                }
                            }
                            &:after{
                                margin-top: 8px;
                            }
                        }

                       /* .field-row .member-dropdown{
                            width: 51.5%;
                        }*/
                        /*

                                            &.quickbooks-container {
                                                padding: 0 0 24px 0 !important;
                                                flex-direction: column;
                                            }


                                            p.seats-desc {
                                                font-size: 0.75rem;
                                                line-height: 1rem;
                                                color: $atto-font-color;
                                                font-family: $roboto-font;
                                                font-weight: 400;
                                                margin-bottom: 16px;
                                            }

                                            .head-labels {
                                                display: flex;
                                                flex-direction: row;
                                                padding: 5px 12px 6px;
                                                margin: 0 48px;
                                                background: #fafafa;
                                                border: 1px solid #efefef;

                                                .label {
                                                    display: inline-flex;
                                                    width: 50%;

                                                    p {
                                                        font-size: 0.75rem;
                                                        line-height: 1.5rem;
                                                        color: $atto-dark-grey;
                                                        font-family: $roboto-font;
                                                        font-weight: 500;
                                                        margin-bottom: 0;
                                                    }
                                                }
                                            }

                                            .field-row {
                                                display: flex;
                                                flex-direction: row;
                                                margin-bottom: 0px !important;
                                                align-items: center;
                                                position: relative;
                                                width: 100%;

                                                p.member-name {

                                                    font-size: 0.875rem;
                                                    line-height: 1.25rem;
                                                    color: $atto-font-color;
                                                    font-family: $roboto-font;
                                                    font-weight: 400;
                                                    margin-bottom: 0px;
                                                }

                                                input {
                                                    border: 2px solid $atto-light-grey;
                                                    padding: 8px 12px;
                                                    font-size: 0.875rem;
                                                    line-height: 1.25rem;
                                                    font-family: $roboto-font;
                                                    font-weight: $roboto-regular;
                                                    color: $atto-font-color;
                                                    width: 100%;
                                                    max-width: 360px;
                                                    -webkit-appearance: none;
                                                    border-radius: 0;
                                                    @include base-transition(ease all 0.10s);

                                                    &:focus {
                                                        border-color: $atto-dark-grey
                                                    }
                                                }

                                                input.error {
                                                    border: 2px solid $atto-red;
                                                }

                                                .checkbox-wrapper {
                                                    margin-right: 16px;
                                                    width: 24px;
                                                }

                                                .check-wrapper {
                                                    .custom-checkbox {
                                                        margin-left: 14px;
                                                    }
                                                }

                                                .member-name {
                                                    flex-grow: 1;
                                                }

                                                .member-dropdown {
                                                    width: calc(50% - 16px);
                                                }

                                                .atto-select {
                                                    margin-right: 0;

                                                    .select-heading {
                                                        width: 100%;
                                                        max-width: 360px;
                                                        flex-direction: row;
                                                        @include base-transition(ease all 0.1s);

                                                        span {
                                                            flex-grow: 1;
                                                            display: inline-flex;
                                                        }

                                                        i {
                                                            @include base-transition(ease all 0.1s);
                                                        }

                                                        &:hover {
                                                            border-color: #c7c7c7;

                                                            i {
                                                                color: #c7c7c7;
                                                            }
                                                        }
                                                    }

                                                    .select-options {
                                                        .heading {
                                                            i {
                                                                margin-right: 0;
                                                                color: #c7c7c7;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                        */

                    }
                }
            }
        }
    }


</style>